import { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";

const SettingsContext = createContext(null);

// Fail-open: until an admin explicitly turns something off in Firestore,
// booking/subscriptions behave exactly as before.
const DEFAULTS = { bookingEnabled: true, subscriptionEnabled: true };

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "settings", "app"), (snap) => {
      setSettings(snap.exists() ? { ...DEFAULTS, ...snap.data() } : DEFAULTS);
    });
    return unsub;
  }, []);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
